import { render, staticRenderFns } from "./RequestReturnGoodsList.vue?vue&type=template&id=74d05ba5&scoped=true"
import script from "./RequestReturnGoodsList.vue?vue&type=script&lang=js"
export * from "./RequestReturnGoodsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d05ba5",
  null
  
)

export default component.exports